import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-income',
  templateUrl: './icon-income.component.html',
  styles: []
})
export class IconIncomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
